<template>
  <div>

    <label :for="forId" class="form-label" v-if="label">
      {{ label }}
      <span :title="$t('dss.label.required')" v-if="required">*</span>
    </label>

    <slot/>

    <div class="error text-danger" v-if="validationErrors" v-for="error in validationErrors">
      <div>{{ error.$message }}</div>
    </div>

    <slot name="after"/>

  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ErrorObject } from '@vuelidate/core';

export default defineComponent({
  name: 'FormGroup',
  emits: ['update:modelValue', 'keydown', 'keyup', 'keypress'],
  props: {
    // label
    forId: String,
    label: String,
    required: { type: Boolean, default: false },
    // errors
    validationErrors: Object as PropType<ErrorObject[]>,
  },
});
</script>

<style scoped>
</style>
